import { PackagingComponentDto } from './packaging-component-dto';

export class ClosureDto extends PackagingComponentDto {
    isRigidComponent = false;
}
